/* global axios */
import ApiClient from './ApiClient';

class LeadAPI extends ApiClient {
  constructor() {
    super('leads', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  listReminders(leadId) {
    return axios.get(`${this.url}/${leadId}/lead_reminders`);
  }

  createReminder(leadId, payload) {
    return axios.post(`${this.url}/${leadId}/lead_reminders`, {
      lead_reminder: payload,
    });
  }

  updateReminder(leadId, reminderId, payload) {
    return axios.patch(`${this.url}/${leadId}/lead_reminders/${reminderId}`, {
      lead_reminder: payload,
    });
  }

  deleteReminder(leadId, reminderId) {
    return axios.delete(`${this.url}/${leadId}/lead_reminders/${reminderId}`);
  }
}

export default new LeadAPI();
